module.exports = __webpack_public_path__ + "static/media/4ODA17.e30ad6c9.jpg";